$(document).ready(() => {
  const scrollContainers = document.querySelectorAll(".scroll-container");

  if (scrollContainers.length) {
    scrollContainers.forEach((element) => {
      const leftbtn = element.querySelector(".scroll-left");
      const rightbtn = element.querySelector(".scroll-right");
      const scroller = element.querySelector(".scroller-div");
      const cardsWidth = element.querySelector(
        ".cards-scroller-width"
      ).offsetWidth;

      if (leftbtn) {
        leftbtn.addEventListener("click", () => scroller.scrollBy(-425, 0));
      }
      if (rightbtn) {
        rightbtn.addEventListener("click", () => scroller.scrollBy(425, 0));
      }

      scroller.addEventListener("scroll", handleScroll);

      function handleScroll() {
        if (scroller.scrollLeft === 0) {
          leftbtn.style.display = "none";
        } else {
          leftbtn.style.display = "flex";
        }

        if (window.innerWidth < 880) {
          if (
            scroller.scrollWidth - scroller.clientWidth ===
            scroller.scrollLeft
          ) {
            rightbtn.style.display = "none";
          } else {
            rightbtn.style.display = "flex";
          }
        } else {
          if (cardsWidth - 425 <= scroller.scrollLeft) {
            rightbtn.style.display = "none";
          } else {
            rightbtn.style.display = "flex";
          }
        }
      }

      handleScroll();
    });
  }

  const spacerCard = document.querySelectorAll(".spacer-card");

  if (window.innerWidth < 800) {
    spacerCard.forEach((el) => {
      el.classList.add("spacer-hide");
    });
  }

  window.addEventListener("resize", () => {
    spacerCard.forEach((el) => {
      el.classList.toggle("spacer-hide", window.innerWidth < 880);
    });
  });
});
